export default __webpack_public_path__ + "static/media/genericImage.8733da6d.svg";